import React from 'react';
import styled from '@emotion/native';
import { white } from '@/shared/styles/colors';
import { BaseText, Link } from '@/shared/components/StyledText';
import { EMME_EVENT_LANDING } from '@/shared/constants/utility';
import { Linking } from 'react-native';

const InPersonInfoTile = () => {
  return (
    <Container>
      <EventImage source={require('@/assets/images/InPersonBackground.png')} />
      <InfoSection>
        <InfoText>Emme at Not A Normal Show – NYC</InfoText>
        <Text>
          Book a styling session live at one of NYC’s biggest vintage fashion
          markets. Emme stylists will be available in person to help you shop
          and find the perfect pieces
        </Text>
        <LinkText onPress={() => Linking.openURL(EMME_EVENT_LANDING)}>
          Learn more about the event
        </LinkText>
      </InfoSection>
    </Container>
  );
};

const Container = styled.View({
  borderRadius: 12,
  marginBottom: 16,
  backgroundColor: white,
});

const EventImage = styled.Image({
  width: '100%',
});

const InfoSection = styled.View({
  marginBottom: 16,
  backgroundColor: white,
  padding: 16,
  paddingBottom: 0,
  borderRadius: 12,
});

const InfoText = styled(BaseText)({
  fontSize: 16,
  fontWeight: 'bold',
  marginBottom: 4,
});

const Text = styled(BaseText)({
  fontSize: 12,
  fontWeight: 'normal',
  marginBottom: 16,
});

const LinkText = styled(Link)({
  fontSize: 12,
  fontWeight: 'normal',
  textDecorationLine: 'underline',
});

export default InPersonInfoTile;
